import { GrantRole, OrganizationRoleType } from "../../../../autogen/bff-api";
import { asOrganizationRole } from "./roleVocabulary";

type Family = "sourcing" | "contract" | "project";

const families: Partial<Record<OrganizationRoleType, Family>> = {
  [OrganizationRoleType.SourcingCreator]: "sourcing",
  [OrganizationRoleType.SourcingViewer]: "sourcing",
  [OrganizationRoleType.ContractCreator]: "contract",
  [OrganizationRoleType.ContractViewer]: "contract",
  [OrganizationRoleType.ProjectCreator]: "project",
  [OrganizationRoleType.ProjectViewer]: "project",
};

const isBlanket = (role: OrganizationRoleType) =>
  role === OrganizationRoleType.Owner || role === OrganizationRoleType.Admin;

/** Mirrors `Person.addRole` in the BFF domain, which applies this server-side whatever we send. */
export const supersededOrganizationRoles = (
  existing: OrganizationRoleType[],
  role: GrantRole
): OrganizationRoleType[] => {
  const added = asOrganizationRole(role);
  if (added === null) return [];
  return existing.filter((held) => {
    if (held === added) return false;
    if (isBlanket(added) || isBlanket(held)) return true;
    return families[added] !== undefined && families[added] === families[held];
  });
};
